import { render, staticRenderFns } from "./DisplayDataInTable.vue?vue&type=template&id=0bbebb7e"
import script from "./DisplayDataInTable.vue?vue&type=script&lang=ts"
export * from "./DisplayDataInTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports